<template>
  <NodePensionFund
    v-if="node && node.__typename === 'NodePensionFund'"
    v-bind="node"
  />
  <NodeEmployer
    v-else-if="node && node.__typename === 'NodeEmployer'"
    v-bind="node"
  />
  <NodeNews v-else-if="node && node.__typename === 'NodeNews'" v-bind="node" />
  <NodeBlog v-else-if="node && node.__typename === 'NodeBlog'" v-bind="node" />
  <NodePage v-else-if="node && node.__typename === 'NodePage'" v-bind="node" />
</template>

<script lang="ts" setup>
defineOptions({
  name: 'PageSlug',
})

const pathSlug = '/:slug(.*)*'
definePageMeta({
  name: 'drupal-route',
  path: pathSlug,
  languageMapping: {
    fr: pathSlug,
    it: pathSlug,
    en: pathSlug,
  },
})

const { entity: node } = await useDrupalRouteQuery('slug')
await renderPageDependencies()
</script>
